import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { COMMON_IMPORTS } from '../../../../../../Shared/common-imports';
import { BillingPlanOption } from '../../../../../../../Interfaces/api/billing.interface';
import { PlanPickerDialogData } from '../../../../../Interfaces/plan-picker-dialog.interface';

@Component({
    selector: 'app-billing-plan-picker-dialog',
    standalone: true,
    imports: [COMMON_IMPORTS],
    templateUrl: './plan-picker-dialog.component.html',
    styleUrls: ['../../billing.scss'],
})
export class PlanPickerDialogComponent {
    readonly data = inject<PlanPickerDialogData>(MAT_DIALOG_DATA);
    private readonly _dialogRef = inject(MatDialogRef<PlanPickerDialogComponent, BillingPlanOption>);

    select(plan: BillingPlanOption): void {
        this._dialogRef.close(plan);
    }

    close(): void {
        this._dialogRef.close();
    }
}
